import { type ReactNode } from "react";

export interface PageContainerProps {
  readonly children: ReactNode;
  readonly title?: string | JSX.Element;
}

export function PageContainer({ children, title }: PageContainerProps) {
  return (
    <div className="container-xl bg-white px-7 p-5 rounded-md h-full border">
      {typeof title === "string" ? (
        <h1 className="heading mx-0 mt-0 mb-3">{title}</h1>
      ) : (
        title
      )}
      {children}
    </div>
  );
}
